import { AppState } from "..";

function selectedFileVersionId(state: AppState, fileId: string): string {
  return state.dataRoomFile.selectedFileVersionId[fileId];
}

export const dataRoomFileSelectors = {
  selectedFileVersionId,
};
